export default {"src":"/_next/static/media/inground.e99115f9.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};